export enum AssetsLayout {
  LIST,
  TILES,
}
